import { BaseAction } from "../../../../core/actions/BaseAction";
import { isEmpty } from "../../../../Lib/Utils/validationUtil";
import { IUserResponse } from "../../../../Orchestrator/Types/Index";
import { ITicketOption } from "../../../../Orchestrator/Types/Interface/ITicketOption";
import { IFavoriteDepartureFields, IFavoriteTripsForTodayFields } from "../../../../Orchestrator/Types/Types/OffersResponse";
import { showNotification } from "../../../../Services/notificationService";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateRailPreferenceAction } from "./UpdateRailPreferenceAction";


interface IUpdateFavoriteTripForTodayParams {
    favoriteDepartureFields: IFavoriteDepartureFields[],
    ticketOptions: ITicketOption[],
    userData: IUserResponse
}

class UpdateFavouriteDepartureAction extends BaseAction<void, IUpdateFavoriteTripForTodayParams> {
    override async run(): Promise<void> {
        try {
            const { favoriteDepartureFields, ticketOptions, userData } = this.params!;
            const favoriteDeparture: any[] = [];
            let currentTrip: any = {};
            favoriteDepartureFields.forEach((field) => {
                if (!isEmpty(field.value)) {
                    console.log("field", field.name);
                    if (field.name === 'from') {
                        currentTrip['origin'] = field.value;
                    } else if (field.name === 'to') {
                        currentTrip['destination'] = field.value;
                    } else if (field.name === 'classTicketOption') {
                        const classType = field.value;
                        currentTrip['classType'] = classType;

                        const matchedOption = ticketOptions.find(
                            d => d.serviceClass === classType && d.value === field.valueCode
                        );
                        currentTrip['ticketOption'] = matchedOption?.value || field.valueCode || "";
                    } else if (field.name === 'outboundDepartureTime') {
                        currentTrip['outboundDepartureTime'] = field.value;
                    }
                }
            });
            favoriteDeparture.push(currentTrip);

            const payload = {
                railPreferences: {
                    ...userData.railPreferences,
                    favoriteDeparture: favoriteDeparture[0]
                }
            };
            updateRailPreferenceAction.setParams({ payload, userId: userData.id });
            await updateRailPreferenceAction.execute();
            showNotification("success", getTranslatedMessage("favoriteDepartureUpdatedSuccessfully", "Favorite departure updated successfully"), "");
        } catch (error: any) {
            console.log("Error updateFavouriteDeparture", error?.message);
        }
    }
}

export const updateFavouriteDepartureAction = new UpdateFavouriteDepartureAction();
